export enum CalendarViewIntervalEnum {
	FIFTEEN_MINUTES = '00:15:00',
	TWENTY_MINUTES = '00:20:00',
	THIRTY_MINUTES = '00:30:00',
	ONE_HOUR = '01:00:00',
	TWO_HOURS = '02:00:00',
	FOUR_HOURS = '04:00:00',
	SIX_HOURS = '06:00:00',
	TWELVE_HOURS = '12:00:00',
}
